

 export const setupNativeBootstrap = () =>{}  
 export const initializeClarity = () =>{}   
 export const initializeFacebookSDK = (deviceId) =>{}   
 export const checkInstallReferrer = (setReferrerInfo, appLanguage, enqueue) =>{}      
